import React from "react";
import {
  Button,
  Space,
  Row,
  Col,
  Dropdown,
  message,
  Modal,
  Image,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import CompanyAutocomplete from "./CompanyAutocomplete";
import RouteManagementAdd from "./RouteManagementAdd";
import ListTable from "./ListTable";

import RouteManagementStore from "../store/RouteManagementStore";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 230;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 130;
    } else if (val.title?.length > 8) {
      val.width = 110;
    } else {
      val.width = 80;
    }
  });

  return arr;
};

class RouteManagementList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.RouteManagementStore = new RouteManagementStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      warehouseList: [],
      companyId: "",
      showUpload: false,
      showDeleteModal: false,
      vehicleId: "",
      deliveryDateFrom: dayjs().format("YYYY-MM-DD"),
      deliveryDateTo: dayjs().format("YYYY-MM-DD"),
      driverName: "",
      salesExecutive: "",
      customerName: "",
      showModal: false,
      jobId: "",
      showmap: false,
      companyVal_Lab: "",
      openRouteManagementForm: false,
      listDataUpdate: false,
      Id: "",
      showAlertModal: false,
      fileList: [],
      uploading: false,
      uploadProgress: 0,
      showCancelJobModal: false,
      cancelJobId: "",
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = widthAdderFunc([
      {
        title: context.translate("_ROUTE_ID_"),
        dataIndex: "Id",
        width: 15,
        ellipsis: { showTitle: true },
        render: (value, record) => (
          <Tooltip placement="topLeft" title={value}>
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("routemanagementlist") &&
                  this.onEdit(record);
              }}
            >
              {value}
            </Link>
          </Tooltip>
        ),
      },
      {
        title: context.translate("_ROUTE_NAME_"),
        dataIndex: "routeName",
        width: 15,
        ellipsis: { showTitle: true },
      },
      {
        title: context.translate("_START_POINT_"),
        dataIndex: "startPoint",
        width: 15,
        ellipsis: { showTitle: true },
        render: (value) => (
          <Tooltip placement="topLeft" title={value}>
            {value}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_END_POINT_"),
        dataIndex: "endPoint",
        width: 15,
        ellipsis: { showTitle: true },
        render: (val) => (
          <Tooltip placement="topLeft" title={val}>
            {val}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_TRIP_DISTANCE_"),
        dataIndex: "tripDistance",
        width: 15,
        ellipsis: { showTitle: true },
      },
      {
        title: context.translate("_TRIP_DURATION_"),
        dataIndex: "tripDuration",
        width: 15,
        ellipsis: { showTitle: true },
      },
      {
        title: context.translate("_TRIP_COST_"),
        dataIndex: "tripCost",
        width: 15,
        ellipsis: { showTitle: true },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "groupname",
        width: 5,
        align: "center",
        ellipsis: { showTitle: true },
        render: (_, record) => (
          <Space>
            {this.props.canUpdate("routemanagementlist") && (
              <Tooltip
                title={this.context.translate("_EDIT_RECORD_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: "19px",
                    width: "14px",
                    borderRadius: "0px",
                    cursor: "pointer",
                  }}
                  src={editIcon}
                  onClick={async (e) => {
                    e.preventDefault();
                    await this.onEdit(record);
                  }}
                />
              </Tooltip>
            )}
            {this.props.canDelete("routemanagementlist") && (
              <Tooltip
                title={this.context.translate("_DELETE_RECORD_")}
                placement="bottom"
              >
                <Image
                  src={require("../assets/images/NewDesign/Delete.png")}
                  style={{ cursor: "pointer", width: "14px" }}
                  onClick={() =>
                    this.setState({
                      openDeleteModal: true,
                      deleteData: record,
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        ),
      },
    ]);
  }

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.RouteManagementStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };

  onEdit = async (record) => {
    const Id = record.Id;

    if (Id) {
      await this.context.viewStateStore.setRouteManagementStates(
        this.state.companyId
      );
      await this.setState({ Id: record.Id, openRouteManagementForm: true });
    }
  };

  onDelete = async (record) => {
    const response = await this.RouteManagementStore.deleteRecord({
      Id: record.Id,
      companyId: record.companyId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  };

  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
    }

    this.setState({ pageSize: 50 });
    this.menuProps = {
      items: [
        {
          label: this.context.translate("_FLEET_MANAGEVEHICLE_DRIVER_TAB_"),
          key: "driver",
        },
        {
          label: this.context.translate("_SALES_PERSON_"),
          key: "salesPerson",
        },
      ],
      onClick: (val) => {
        if (val.key === "driver") {
          this.RouteManagementStore.sampleExcelDriver();
        }
        if (val.key === "salesPerson") {
          this.RouteManagementStore.sampleExcelSalesPerson();
        }
      },
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.showmap !== prevState.showmap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setJobData = this.context.viewStateStore.RouteManagementObject;

      if (setJobData.companyId !== "") {
        await this.RouteManagementStore.loadData({
          companyId: setJobData.companyId,
        });

        const data = await this.RouteManagementStore.getAllVehicles(
          setJobData.companyId
        );

        const singleData = await this.companyStore.getCompanyDataById(
          setJobData.companyId
        );

        await this.setState({
          loadList: 1,
          companyVal_Lab: singleData,
          companyId: setJobData.companyId,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  // async handleChange(comp) {
  //   const singleData = await this.companyStore.getCompanyDataById(comp.value);
  //   this.setState({
  //     companyId: comp.value,
  //     companyVal_Lab: singleData,
  //     vehicleId: "",
  //     salesExecutive: "",
  //     driverName: "",
  //     jobId: "",
  //   });

  //   console.log("compid", this.state.companyId);

  //   await this.handleSearch();
  //   await this.setState({ loadList: 1 });
  // }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      vehicleId: "",
      salesExecutive: "",
      driverName: "",
      jobId: "",
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData, companyId: comp.value });
    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.RouteManagementStore.loadData({
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  searchClick = async () => {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false, loading: true });

      await this.RouteManagementStore.loadData({
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    }
  };

  deleteJob = async (value) => {
    let flag = 0;

    value.forEach(async (id) => {
      const data = {
        Id: id,
        companyId: this.state.companyId,
      };

      const response = await this.RouteManagementStore.deleteRecord(data);

      if (response?.data?.success === "S") {
        if (flag === 0) {
          message.success(response.data.message);
        }

        this.handleSearch();
        flag++;
      } else {
        message.error(response.data.message);
      }
    });
  };

  show = () => {
    this.setState({ showmap: true });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({
        listDataUpdate: true,
        openRouteManagementForm: false,
      });

      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };

  closeModal = () => {
    this.setState({ openRouteManagementForm: false, Id: "" });
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 140 }}
                  status={this.state.companyFieldHighlight ? "error" : false}
                />
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                />
              </Tooltip>

              {this.props.canCreate("routemanagementlist") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openRouteManagementForm: true, fuelId: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  />
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            // rowSelection={{
            //   selectedRowKeys: this.state.jobId,
            //   onChange: async (selectedRowKeys) => {
            //     await this.setState({ jobId: selectedRowKeys });
            //   },
            // }}
            rowKey="Id"
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.RouteManagementStore?.total}
            columns={this.columns}
            dataSource={this.RouteManagementStore?.RouteManagement}
            loading={this.RouteManagementStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openRouteManagementForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openRouteManagementForm}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_ROUTE_MANAGEMENT_")}
                  <p className="formDescription">
                    {this.context.translate("_ROUTE_MANAGEMENT_ADD_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openRouteManagementForm: false })}
              onCancel={() =>
                this.setState({ openRouteManagementForm: false, Id: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <RouteManagementAdd
                  Id={this.state.Id}
                  companyId={this.state.companyId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}

RouteManagementList.contextType = StoreContext;
export default observer(withRouter(RouteManagementList));
